module.exports = __webpack_public_path__ + "media/images/logo/unica-logo-4955d6499ea19370fbecaaf99db98239.svg";